// Code generated by golem generate trackers. DO NOT EDIT.
import { z } from "zod";

export type AnalyticsTransport = (
    eventName: string,
    params: Record<string, unknown>,
) => void | Promise<void>;

export const BbhorizonUserClicksTabbuttonEventName = "bbhorizon - user clicks tabbutton";
export const BbhorizonUserClicksTabbuttonPayloadSchema = z.object({
    logAs: z.boolean(),
    companyId: z.string(),
    companyName: z.string(),
    network: z.boolean(),
    industry: z.string().optional(),
    networkName: z.string().optional(),
});
export type BbhorizonUserClicksTabbuttonPayload = z.infer<
    typeof BbhorizonUserClicksTabbuttonPayloadSchema
>;

export const BbhorizonUserClicksToDisplayFormEventName = "bbhorizon - user clicks to display form";
export const BbhorizonUserClicksToDisplayFormPayloadSchema = z.object({
    logAs: z.boolean(),
    companyId: z.string(),
    companyName: z.string(),
    network: z.boolean(),
    industry: z.string().optional(),
    networkName: z.string().optional(),
});
export type BbhorizonUserClicksToDisplayFormPayload = z.infer<
    typeof BbhorizonUserClicksToDisplayFormPayloadSchema
>;

export const BbhorizonUserSendsCdiRequestEventName = "bbhorizon - user sends cdi request";
export const BbhorizonUserSendsCdiRequestPayloadSchema = z.object({
    logAs: z.boolean(),
    companyId: z.string(),
    companyName: z.string(),
    network: z.boolean(),
    industry: z.string().optional(),
    networkName: z.string().optional(),
});
export type BbhorizonUserSendsCdiRequestPayload = z.infer<
    typeof BbhorizonUserSendsCdiRequestPayloadSchema
>;

export const BbhorizonUserWebNotificationEventName = "bbhorizon - user web notification";
export const BbhorizonUserWebNotificationPayloadSchema = z.object({
    logAs: z.boolean(),
    companyId: z.string(),
    companyName: z.string(),
    network: z.boolean(),
    industry: z.string().optional(),
    networkName: z.string().optional(),
});
export type BbhorizonUserWebNotificationPayload = z.infer<
    typeof BbhorizonUserWebNotificationPayloadSchema
>;

export const BulkshiftCreatedShiftEventName = "bulkshift - created shift";
export const BulkshiftCreatedShiftPayloadSchema = z.object({
    industry: z.string().optional(),
    slots: z.number(),
    startDate: z.string(),
    endDate: z.string(),
    breakDuration: z.number(),
    shiftDuration: z.number(),
    recurrence: z.boolean(),
    recurrenceWithHolidays: z.boolean().optional(),
    recurrenceUntil: z.string().optional(),
    recurrenceType: z.string().optional(),
    recurrenceInterval: z.number().optional(),
    recurrenceDurationInDays: z.number().optional(),
    recurrenceMonthlyWeekdayPosition: z.string().optional(),
    recurrenceMonthlyWeekday: z.string().optional(),
    recurrenceMonthlySameDate: z.number().optional(),
    monday: z.boolean().optional(),
    tuesday: z.boolean().optional(),
    wednesday: z.boolean().optional(),
    thursday: z.boolean().optional(),
    friday: z.boolean().optional(),
    saturday: z.boolean().optional(),
    sunday: z.boolean().optional(),
    taskId: z.string().optional(),
    logAs: z.any().optional(),
});
export type BulkshiftCreatedShiftPayload = z.infer<typeof BulkshiftCreatedShiftPayloadSchema>;

export const BulkshiftDeletedShiftEventName = "bulkshift - deleted shift";
export const BulkshiftDeletedShiftPayloadSchema = z.object({
    industry: z.string().optional(),
    slots: z.number(),
    startDate: z.string(),
    endDate: z.string(),
    breakDuration: z.number(),
    shiftDuration: z.number(),
    recurrence: z.boolean(),
    recurrenceWithHolidays: z.boolean().optional(),
    recurrenceUntil: z.string().optional(),
    recurrenceType: z.string().optional(),
    recurrenceInterval: z.number().optional(),
    recurrenceDurationInDays: z.number().optional(),
    recurrenceMonthlyWeekdayPosition: z.string().optional(),
    recurrenceMonthlyWeekday: z.string().optional(),
    recurrenceMonthlySameDate: z.number().optional(),
    monday: z.boolean().optional(),
    tuesday: z.boolean().optional(),
    wednesday: z.boolean().optional(),
    thursday: z.boolean().optional(),
    friday: z.boolean().optional(),
    saturday: z.boolean().optional(),
    sunday: z.boolean().optional(),
    taskId: z.string().optional(),
    logAs: z.any().optional(),
});
export type BulkshiftDeletedShiftPayload = z.infer<typeof BulkshiftDeletedShiftPayloadSchema>;

export const BulkshiftDeletedShiftsEventName = "bulkshift - deleted shifts";
export const BulkshiftDeletedShiftsPayloadSchema = z.object({
    shiftsDeleted: z.number(),
    industry: z.string().optional(),
    taskId: z.string().optional(),
    logAs: z.any().optional(),
});
export type BulkshiftDeletedShiftsPayload = z.infer<typeof BulkshiftDeletedShiftsPayloadSchema>;

export const BulkshiftEditedShiftEventName = "bulkshift - edited shift";
export const BulkshiftEditedShiftPayloadSchema = z.object({
    industry: z.string().optional(),
    slots: z.number(),
    startDate: z.string(),
    endDate: z.string(),
    breakDuration: z.number(),
    shiftDuration: z.number(),
    recurrence: z.boolean(),
    recurrenceWithHolidays: z.boolean().optional(),
    recurrenceUntil: z.string().optional(),
    recurrenceType: z.string().optional(),
    recurrenceInterval: z.number().optional(),
    recurrenceDurationInDays: z.number().optional(),
    recurrenceMonthlyWeekdayPosition: z.string().optional(),
    recurrenceMonthlyWeekday: z.string().optional(),
    recurrenceMonthlySameDate: z.number().optional(),
    monday: z.boolean().optional(),
    tuesday: z.boolean().optional(),
    wednesday: z.boolean().optional(),
    thursday: z.boolean().optional(),
    friday: z.boolean().optional(),
    saturday: z.boolean().optional(),
    sunday: z.boolean().optional(),
    taskId: z.string().optional(),
    logAs: z.any().optional(),
});
export type BulkshiftEditedShiftPayload = z.infer<typeof BulkshiftEditedShiftPayloadSchema>;

export const CompanyfeedbackSaveEventName = "companyfeedback - save";
export const CompanyfeedbackSavePayloadSchema = z.object({
    companyID: z.string(),
    taskID: z.string(),
    date: z.string(),
    siderID: z.string(),
});
export type CompanyfeedbackSavePayload = z.infer<typeof CompanyfeedbackSavePayloadSchema>;

export const CompanymotivesCreatedJustificationEventName = "companymotives - created justification";
export const CompanymotivesCreatedJustificationPayloadSchema = z.object({
    orgId: z.string(),
    reason: z.string(),
});
export type CompanymotivesCreatedJustificationPayload = z.infer<
    typeof CompanymotivesCreatedJustificationPayloadSchema
>;

export const CompanymotivesDeletedJustificationEventName = "companymotives - deleted justification";
export const CompanymotivesDeletedJustificationPayloadSchema = z.object({
    orgId: z.string(),
    reason: z.string(),
});
export type CompanymotivesDeletedJustificationPayload = z.infer<
    typeof CompanymotivesDeletedJustificationPayloadSchema
>;

export const ContactsidersEventName = "contactSiders";
export const ContactsidersPayloadSchema = z.object({});
export type ContactsidersPayload = z.infer<typeof ContactsidersPayloadSchema>;

export const CreatedaccountEventName = "createdAccount";
export const CreatedaccountPayloadSchema = z.object({});
export type CreatedaccountPayload = z.infer<typeof CreatedaccountPayloadSchema>;

export const CreatedprofileEventName = "createdProfile";
export const CreatedprofilePayloadSchema = z.object({});
export type CreatedprofilePayload = z.infer<typeof CreatedprofilePayloadSchema>;

export const DashboardOpenedTabEventName = "dashboard - opened tab";
export const DashboardOpenedTabPayloadSchema = z.object({
    organisationId: z.string(),
    logAs: z.any(),
});
export type DashboardOpenedTabPayload = z.infer<typeof DashboardOpenedTabPayloadSchema>;

export const FeatureusedEventName = "featureUsed";
export const FeatureusedPayloadSchema = z.object({});
export type FeatureusedPayload = z.infer<typeof FeatureusedPayloadSchema>;

export const FeedbackCompletedRatingEventName = "feedback - completed rating";
export const FeedbackCompletedRatingPayloadSchema = z.object({});
export type FeedbackCompletedRatingPayload = z.infer<typeof FeedbackCompletedRatingPayloadSchema>;

export const FeedbackStoppedRatingEventName = "feedback - stopped rating";
export const FeedbackStoppedRatingPayloadSchema = z.object({});
export type FeedbackStoppedRatingPayload = z.infer<typeof FeedbackStoppedRatingPayloadSchema>;

export const GetidentificationdataEventName = "getIdentificationData";
export const GetidentificationdataPayloadSchema = z.object({});
export type GetidentificationdataPayload = z.infer<typeof GetidentificationdataPayloadSchema>;

export const GuestfeedbackFeedbackSentEventName = "guestfeedback - feedback sent";
export const GuestfeedbackFeedbackSentPayloadSchema = z.object({
    taskId: z.string(),
    siderId: z.string(),
    mobile: z.boolean(),
});
export type GuestfeedbackFeedbackSentPayload = z.infer<
    typeof GuestfeedbackFeedbackSentPayloadSchema
>;

export const GuestfeedbackOpenEventName = "guestfeedback - open";
export const GuestfeedbackOpenPayloadSchema = z.object({
    taskId: z.string(),
    mobile: z.boolean(),
});
export type GuestfeedbackOpenPayload = z.infer<typeof GuestfeedbackOpenPayloadSchema>;

export const InvitedteammemberEventName = "invitedTeamMember";
export const InvitedteammemberPayloadSchema = z.object({});
export type InvitedteammemberPayload = z.infer<typeof InvitedteammemberPayloadSchema>;

export const InvoicesBulkDownloadEventName = "invoices - bulk download";
export const InvoicesBulkDownloadPayloadSchema = z.object({
    fileType: z.any(),
});
export type InvoicesBulkDownloadPayload = z.infer<typeof InvoicesBulkDownloadPayloadSchema>;

export const InvoicesSingleInvoiceDownloadEventName = "invoices - single invoice download";
export const InvoicesSingleInvoiceDownloadPayloadSchema = z.object({});
export type InvoicesSingleInvoiceDownloadPayload = z.infer<
    typeof InvoicesSingleInvoiceDownloadPayloadSchema
>;

export const IsnewaccountEventName = "isNewAccount";
export const IsnewaccountPayloadSchema = z.object({});
export type IsnewaccountPayload = z.infer<typeof IsnewaccountPayloadSchema>;

export const JobDescriptionsCreateJobDescriptionEventName =
    "job-descriptions - create job description";
export const JobDescriptionsCreateJobDescriptionPayloadSchema = z.object({
    source: z.string(),
    organisationId: z.string(),
    logAs: z.any().optional(),
});
export type JobDescriptionsCreateJobDescriptionPayload = z.infer<
    typeof JobDescriptionsCreateJobDescriptionPayloadSchema
>;

export const JobDescriptionsUseJobDescriptionEventName = "job-descriptions - use job description";
export const JobDescriptionsUseJobDescriptionPayloadSchema = z.object({
    source: z.string(),
    organisationId: z.string(),
    jobTitle: z.string(),
    logAs: z.any().optional(),
});
export type JobDescriptionsUseJobDescriptionPayload = z.infer<
    typeof JobDescriptionsUseJobDescriptionPayloadSchema
>;

export const JobpostingAddExternalWorkAgainEventName = "jobposting - add external work again";
export const JobpostingAddExternalWorkAgainPayloadSchema = z.object({
    organisationId: z.string(),
    taskId: z.string(),
    siderId: z.string(),
    logAs: z.string().optional(),
});
export type JobpostingAddExternalWorkAgainPayload = z.infer<
    typeof JobpostingAddExternalWorkAgainPayloadSchema
>;

export const JobpostingAddedCustomNameEventName = "jobposting - added custom name";
export const JobpostingAddedCustomNamePayloadSchema = z.object({
    logAs: z.any(),
    duplicated: z.boolean(),
});
export type JobpostingAddedCustomNamePayload = z.infer<
    typeof JobpostingAddedCustomNamePayloadSchema
>;

export const JobpostingEstimationClickedEventName = "jobposting - estimation clicked";
export const JobpostingEstimationClickedPayloadSchema = z.object({
    taskId: z.string(),
    step: z.string(),
});
export type JobpostingEstimationClickedPayload = z.infer<
    typeof JobpostingEstimationClickedPayloadSchema
>;

export const JobpostingFlexiblePlanningPostedEventName = "jobposting - flexible planning posted";
export const JobpostingFlexiblePlanningPostedPayloadSchema = z.object({
    startDate: z.string(),
    endDate: z.string(),
    slots: z.number(),
    hourlyVolume: z.number(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    amplitudeTotalDurationInMinutes: z.number(),
    includesWeekDays: z.boolean(),
    includesHolidays: z.boolean(),
    includesSaturday: z.boolean(),
    includesSunday: z.boolean(),
    taskId: z.string(),
});
export type JobpostingFlexiblePlanningPostedPayload = z.infer<
    typeof JobpostingFlexiblePlanningPostedPayloadSchema
>;

export const JobpostingPlanningTypeSelectedEventName = "jobposting - planning type selected";
export const JobpostingPlanningTypeSelectedPayloadSchema = z.object({
    type: z.string(),
});
export type JobpostingPlanningTypeSelectedPayload = z.infer<
    typeof JobpostingPlanningTypeSelectedPayloadSchema
>;

export const JobpostingStartedPostingTaskEventName = "jobposting - started posting task";
export const JobpostingStartedPostingTaskPayloadSchema = z.object({
    logAs: z.any(),
    duplicated: z.boolean(),
    jobType: z.string().optional(),
    organisationId: z.string(),
    translatedJobType: z.string(),
});
export type JobpostingStartedPostingTaskPayload = z.infer<
    typeof JobpostingStartedPostingTaskPayloadSchema
>;

export const JobpostingTaskPostedEventName = "jobposting - task posted";
export const JobpostingTaskPostedPayloadSchema = z.object({
    type: z.string(),
    jobTitle: z.string(),
    normalGrossHourlyRate: z.number(),
    salary: z.number(),
    totalExcludingTaxesEstimated: z.number(),
    name: z.string(),
    organisationId: z.string(),
    taskId: z.string(),
    logAs: z.any(),
    replacement: z.boolean(),
    hexaCellResFour: z.string().optional(),
    hexaCellResFive: z.string().optional(),
    hexaCellResSix: z.string().optional(),
    hexaCellResSeven: z.string().optional(),
});
export type JobpostingTaskPostedPayload = z.infer<typeof JobpostingTaskPostedPayloadSchema>;

export const JobpostingUserClickedPreselectVivierEventName =
    "jobposting - user clicked preselect vivier";
export const JobpostingUserClickedPreselectVivierPayloadSchema = z.object({
    logAs: z.boolean(),
    taskId: z.string(),
    taskIsDraft: z.boolean(),
    numberOfAvailableSiderInPreselect: z.number(),
    orgId: z.string(),
    networkId: z.string().optional(),
    isLoading: z.boolean(),
});
export type JobpostingUserClickedPreselectVivierPayload = z.infer<
    typeof JobpostingUserClickedPreselectVivierPayloadSchema
>;

export const JobpostingUserSelectSidersEventName = "jobposting - user select siders";
export const JobpostingUserSelectSidersPayloadSchema = z.object({
    logAs: z.boolean(),
    orgId: z.string(),
    networkId: z.string().optional(),
    taskId: z.string(),
    nbAvailableWA: z.number(),
    nbAvailablePreselect: z.number().optional(),
    nbSelectedWA: z.number(),
    nbSelectedPreselect: z.number().optional(),
    waOnly: z.boolean(),
    isPreselectionLoading: z.boolean().optional(),
    hasPreselectionActivated: z.boolean(),
});
export type JobpostingUserSelectSidersPayload = z.infer<
    typeof JobpostingUserSelectSidersPayloadSchema
>;

export const JobpostingVmsDraftModificationEventName = "jobposting - vms draft modification";
export const JobpostingVmsDraftModificationPayloadSchema = z.object({
    organisationId: z.string(),
    taskId: z.string(),
    origin: z.string(),
    step: z.string(),
});
export type JobpostingVmsDraftModificationPayload = z.infer<
    typeof JobpostingVmsDraftModificationPayloadSchema
>;

export const MissionCancellationEventName = "mission - cancellation";
export const MissionCancellationPayloadSchema = z.object({
    organisationId: z.string(),
    source: z.string(),
    shifts: z.number(),
    startDate: z.any(),
    endDate: z.any(),
    isLogAs: z.boolean(),
    taskId: z.string(),
});
export type MissionCancellationPayload = z.infer<typeof MissionCancellationPayloadSchema>;

export const NetworktasksLoadViewEventName = "networktasks - load view";
export const NetworktasksLoadViewPayloadSchema = z.object({
    dateMode: z.string(),
    dateValue: z.string(),
    initial: z.boolean(),
    networkId: z.string(),
    orderBy: z.string().optional(),
    groupBy: z.string().optional(),
    organisations: z.any().optional(),
    siderId: z.string().optional(),
    managerId: z.string().optional(),
    selectionStatus: z.string().optional(),
    logAs: z.any().optional(),
});
export type NetworktasksLoadViewPayload = z.infer<typeof NetworktasksLoadViewPayloadSchema>;

export const OrgaUserCompletedSignupFormEventName = "orga - user completed signup form";
export const OrgaUserCompletedSignupFormPayloadSchema = z.object({
    email: z.string(),
    phoneNumber: z.string(),
    firstName: z.string(),
    lastName: z.string(),
});
export type OrgaUserCompletedSignupFormPayload = z.infer<
    typeof OrgaUserCompletedSignupFormPayloadSchema
>;

export const PaidstudentEventName = "paidStudent";
export const PaidstudentPayloadSchema = z.object({});
export type PaidstudentPayload = z.infer<typeof PaidstudentPayloadSchema>;

export const PlanningEditionDraftEventName = "planning - edition draft";
export const PlanningEditionDraftPayloadSchema = z.object({
    actionType: z.string(),
    create: z.number(),
    edit: z.number(),
    duplicate: z.number(),
    delete: z.number(),
    reason: z.string().optional(),
    isLogAs: z.boolean(),
    taskId: z.string(),
});
export type PlanningEditionDraftPayload = z.infer<typeof PlanningEditionDraftPayloadSchema>;

export const PlanningEditionSavedEventName = "planning - edition saved";
export const PlanningEditionSavedPayloadSchema = z.object({
    organisationId: z.string(),
    create: z.number(),
    edit: z.number(),
    delete: z.number(),
    isLogAs: z.boolean(),
    taskId: z.string(),
});
export type PlanningEditionSavedPayload = z.infer<typeof PlanningEditionSavedPayloadSchema>;

export const PlanningUserDownloadsPlanningEventName = "planning - user downloads planning";
export const PlanningUserDownloadsPlanningPayloadSchema = z.object({
    organisationId: z.any(),
    logAs: z.any(),
    format: z.string(),
});
export type PlanningUserDownloadsPlanningPayload = z.infer<
    typeof PlanningUserDownloadsPlanningPayloadSchema
>;

export const PostingUserExpandPricingEventName = "posting - user expand pricing";
export const PostingUserExpandPricingPayloadSchema = z.object({
    organisationId: z.string(),
    isLogAs: z.boolean(),
    type: z.string(),
    jobDescriptionId: z.string(),
});
export type PostingUserExpandPricingPayload = z.infer<typeof PostingUserExpandPricingPayloadSchema>;

export const PostingUserSwitchedTaskTypeEventName = "posting - user switched task type";
export const PostingUserSwitchedTaskTypePayloadSchema = z.object({
    taskId: z.string(),
    organisationId: z.string(),
    type: z.string(),
    logAs: z.boolean(),
});
export type PostingUserSwitchedTaskTypePayload = z.infer<
    typeof PostingUserSwitchedTaskTypePayloadSchema
>;

export const ProfileteamClosedSiderProfileDetailsEventName =
    "profileteam - closed sider profile details";
export const ProfileteamClosedSiderProfileDetailsPayloadSchema = z.object({
    organisationId: z.string(),
    logAs: z.any(),
    siderId: z.string(),
});
export type ProfileteamClosedSiderProfileDetailsPayload = z.infer<
    typeof ProfileteamClosedSiderProfileDetailsPayloadSchema
>;

export const ProfileteamOpenedConversationsEventName = "profileteam - opened conversations";
export const ProfileteamOpenedConversationsPayloadSchema = z.object({
    organisationId: z.string(),
    logAs: z.any(),
    siderId: z.string(),
});
export type ProfileteamOpenedConversationsPayload = z.infer<
    typeof ProfileteamOpenedConversationsPayloadSchema
>;

export const ProfileteamOpenedEducationSectionEventName = "profileteam - opened education section";
export const ProfileteamOpenedEducationSectionPayloadSchema = z.object({
    organisationId: z.string(),
    logAs: z.string(),
    siderId: z.string(),
});
export type ProfileteamOpenedEducationSectionPayload = z.infer<
    typeof ProfileteamOpenedEducationSectionPayloadSchema
>;

export const ProfileteamOpenedPastExperiencesSectionEventName =
    "profileteam - opened past experiences section";
export const ProfileteamOpenedPastExperiencesSectionPayloadSchema = z.object({
    organisationId: z.string(),
    logAs: z.any(),
    siderId: z.string(),
});
export type ProfileteamOpenedPastExperiencesSectionPayload = z.infer<
    typeof ProfileteamOpenedPastExperiencesSectionPayloadSchema
>;

export const ProfileteamOpenedSideMissionsSectionEventName =
    "profileteam - opened side missions section";
export const ProfileteamOpenedSideMissionsSectionPayloadSchema = z.object({
    organisationId: z.string(),
    logAs: z.any(),
    siderId: z.string(),
});
export type ProfileteamOpenedSideMissionsSectionPayload = z.infer<
    typeof ProfileteamOpenedSideMissionsSectionPayloadSchema
>;

export const ProfileteamOpenedSiderProfileDetailsEventName =
    "profileteam - opened sider profile details";
export const ProfileteamOpenedSiderProfileDetailsPayloadSchema = z.object({
    organisationId: z.string(),
    logAs: z.any(),
    siderId: z.string(),
});
export type ProfileteamOpenedSiderProfileDetailsPayload = z.infer<
    typeof ProfileteamOpenedSiderProfileDetailsPayloadSchema
>;

export const ReplacementToggleReplacementEventName = "replacement - toggle replacement";
export const ReplacementToggleReplacementPayloadSchema = z.object({
    replacement: z.boolean(),
    origin: z.string(),
    organisationId: z.string(),
});
export type ReplacementToggleReplacementPayload = z.infer<
    typeof ReplacementToggleReplacementPayloadSchema
>;

export const SelectedjobtypeEventName = "selectedJobType";
export const SelectedjobtypePayloadSchema = z.object({});
export type SelectedjobtypePayload = z.infer<typeof SelectedjobtypePayloadSchema>;

export const ServicesServiceCreatedEventName = "services - service created";
export const ServicesServiceCreatedPayloadSchema = z.object({
    organisationId: z.string(),
    organisationName: z.string(),
    serviceId: z.string(),
    name: z.string(),
    code: z.string().optional(),
});
export type ServicesServiceCreatedPayload = z.infer<typeof ServicesServiceCreatedPayloadSchema>;

export const SiderProfilePhoneNumberActionEventName = "sider-profile - phone number action";
export const SiderProfilePhoneNumberActionPayloadSchema = z.object({
    timestamp: z.string(),
    action: z.string(),
    logAs: z.boolean(),
    organisationId: z.string(),
});
export type SiderProfilePhoneNumberActionPayload = z.infer<
    typeof SiderProfilePhoneNumberActionPayloadSchema
>;

export const SignedinEventName = "signedIn";
export const SignedinPayloadSchema = z.object({});
export type SignedinPayload = z.infer<typeof SignedinPayloadSchema>;

export const StartedjobcreationEventName = "startedJobCreation";
export const StartedjobcreationPayloadSchema = z.object({});
export type StartedjobcreationPayload = z.infer<typeof StartedjobcreationPayloadSchema>;

export const StartednewjobpostingEventName = "startedNewJobPosting";
export const StartednewjobpostingPayloadSchema = z.object({});
export type StartednewjobpostingPayload = z.infer<typeof StartednewjobpostingPayloadSchema>;

export const TaskUserDisplaysEstimationEventName = "task - user displays estimation";
export const TaskUserDisplaysEstimationPayloadSchema = z.object({
    type: z.string(),
    organisationId: z.string(),
    taskId: z.string(),
    step: z.string(),
    isLogAs: z.boolean(),
});
export type TaskUserDisplaysEstimationPayload = z.infer<
    typeof TaskUserDisplaysEstimationPayloadSchema
>;

export const TasksChangeManagerOfTheTaskEventName = "tasks - change manager of the task";
export const TasksChangeManagerOfTheTaskPayloadSchema = z.object({
    taskId: z.any(),
    logAs: z.any(),
    organizationId: z.any(),
    deviceType: z.any(),
    currentManager: z.any(),
    newManager: z.any(),
});
export type TasksChangeManagerOfTheTaskPayload = z.infer<
    typeof TasksChangeManagerOfTheTaskPayloadSchema
>;

export const TaskslistRenamedTaskEventName = "taskslist - renamed task";
export const TaskslistRenamedTaskPayloadSchema = z.object({
    logAs: z.any(),
});
export type TaskslistRenamedTaskPayload = z.infer<typeof TaskslistRenamedTaskPayloadSchema>;

export const TeamGetViewportResolutionEventName = "team - get viewport resolution";
export const TeamGetViewportResolutionPayloadSchema = z.object({
    viewport: z.string(),
});
export type TeamGetViewportResolutionPayload = z.infer<
    typeof TeamGetViewportResolutionPayloadSchema
>;

export const TeamIbanUpdatedEventName = "team - iban updated";
export const TeamIbanUpdatedPayloadSchema = z.object({
    organisationId: z.string(),
    networkId: z.string().optional(),
    logAs: z.any(),
    action: z.string(),
    paymentMethodType: z.string(),
    organisationName: z.string(),
    networkName: z.string().optional(),
});
export type TeamIbanUpdatedPayload = z.infer<typeof TeamIbanUpdatedPayloadSchema>;

export const TeamRecapPageSeenEventName = "team - recap page seen";
export const TeamRecapPageSeenPayloadSchema = z.object({
    origin: z.string().optional(),
    logAs: z.boolean(),
    taskId: z.string(),
    orgId: z.string(),
});
export type TeamRecapPageSeenPayload = z.infer<typeof TeamRecapPageSeenPayloadSchema>;

export const TeamUpdateTaskFromTaskSummaryEventName = "team - update task from task summary";
export const TeamUpdateTaskFromTaskSummaryPayloadSchema = z.object({
    logAs: z.boolean(),
    taskId: z.string(),
    orgId: z.string(),
    field: z.string(),
});
export type TeamUpdateTaskFromTaskSummaryPayload = z.infer<
    typeof TeamUpdateTaskFromTaskSummaryPayloadSchema
>;

export const TeamcontractCompanyConfirmedContestationEventName =
    "teamcontract - company confirmed contestation";
export const TeamcontractCompanyConfirmedContestationPayloadSchema = z.object({
    logAs: z.any(),
    organisationId: z.any(),
    contractId: z.any(),
    taskId: z.any(),
    status: z.any(),
    source: z.string().optional(),
});
export type TeamcontractCompanyConfirmedContestationPayload = z.infer<
    typeof TeamcontractCompanyConfirmedContestationPayloadSchema
>;

export const TeamcontractCompanyContestedContractsEventName =
    "teamcontract - company contested contracts";
export const TeamcontractCompanyContestedContractsPayloadSchema = z.object({
    logAs: z.any(),
    organisationId: z.any(),
    contractId: z.any(),
    taskId: z.any(),
    status: z.any(),
    source: z.string().optional(),
});
export type TeamcontractCompanyContestedContractsPayload = z.infer<
    typeof TeamcontractCompanyContestedContractsPayloadSchema
>;

export const TeamcontractCompanyDownloadedContractEventName =
    "teamcontract - company downloaded contract";
export const TeamcontractCompanyDownloadedContractPayloadSchema = z.object({
    logAs: z.any(),
    organisationId: z.any(),
    contractId: z.any(),
    taskId: z.any(),
    source: z.string().optional(),
});
export type TeamcontractCompanyDownloadedContractPayload = z.infer<
    typeof TeamcontractCompanyDownloadedContractPayloadSchema
>;

export const TeamcontractCompanyOpenedMainViewEventName = "teamcontract - company opened main view";
export const TeamcontractCompanyOpenedMainViewPayloadSchema = z.object({
    logAs: z.any(),
    organisationId: z.any(),
    source: z.string().optional(),
});
export type TeamcontractCompanyOpenedMainViewPayload = z.infer<
    typeof TeamcontractCompanyOpenedMainViewPayloadSchema
>;

export const TeamcontractCompanySawContractsEventName = "teamcontract - company saw contracts";
export const TeamcontractCompanySawContractsPayloadSchema = z.object({
    logAs: z.any(),
    organisationId: z.any(),
    contractId: z.any(),
    taskId: z.any(),
    status: z.any(),
    source: z.string().optional(),
});
export type TeamcontractCompanySawContractsPayload = z.infer<
    typeof TeamcontractCompanySawContractsPayloadSchema
>;

export const TeamcontractCompanySignedContractsEventName =
    "teamcontract - company signed contracts";
export const TeamcontractCompanySignedContractsPayloadSchema = z.object({
    logAs: z.any(),
    organisationId: z.any(),
    contractId: z.any(),
    taskId: z.any(),
    status: z.any(),
    source: z.string().optional(),
});
export type TeamcontractCompanySignedContractsPayload = z.infer<
    typeof TeamcontractCompanySignedContractsPayloadSchema
>;

export const TeamcontractInsiderRegeneratedContractEventName =
    "teamcontract - insider regenerated contract";
export const TeamcontractInsiderRegeneratedContractPayloadSchema = z.object({
    logAs: z.any(),
    organisationId: z.any(),
    contractId: z.any(),
    taskId: z.any(),
    startDate: z.any(),
    source: z.string().optional(),
});
export type TeamcontractInsiderRegeneratedContractPayload = z.infer<
    typeof TeamcontractInsiderRegeneratedContractPayloadSchema
>;

export const TimesheetConfirmsAttendanceEditEventName = "timesheet - confirms attendance edit";
export const TimesheetConfirmsAttendanceEditPayloadSchema = z.object({
    organisationId: z.string(),
    organisationName: z.string(),
    shiftId: z.string(),
});
export type TimesheetConfirmsAttendanceEditPayload = z.infer<
    typeof TimesheetConfirmsAttendanceEditPayloadSchema
>;

export const TimesheetDisputeAttendanceEventName = "timesheet - dispute attendance";
export const TimesheetDisputeAttendancePayloadSchema = z.object({
    organisationId: z.string(),
    shiftId: z.string(),
    source: z.string().optional(),
    multiple: z.boolean(),
    organisationName: z.string(),
});
export type TimesheetDisputeAttendancePayload = z.infer<
    typeof TimesheetDisputeAttendancePayloadSchema
>;

export const TimesheetDownloadCsvExtractEventName = "timesheet - download csv extract";
export const TimesheetDownloadCsvExtractPayloadSchema = z.object({
    logas: z.any(),
    companyId: z.any(),
});
export type TimesheetDownloadCsvExtractPayload = z.infer<
    typeof TimesheetDownloadCsvExtractPayloadSchema
>;

export const TimesheetEditsAttendanceEventName = "timesheet - edits attendance";
export const TimesheetEditsAttendancePayloadSchema = z.object({
    organisationId: z.string(),
    organisationName: z.string(),
    shiftId: z.string(),
});
export type TimesheetEditsAttendancePayload = z.infer<typeof TimesheetEditsAttendancePayloadSchema>;

export const TimesheetFiltersEventName = "timesheet - filters";
export const TimesheetFiltersPayloadSchema = z.object({
    filters: z.any(),
});
export type TimesheetFiltersPayload = z.infer<typeof TimesheetFiltersPayloadSchema>;

export const TimesheetSelectAllEventName = "timesheet - select all";
export const TimesheetSelectAllPayloadSchema = z.object({
    organisationId: z.string(),
    organisationName: z.string(),
    logAs: z.boolean(),
});
export type TimesheetSelectAllPayload = z.infer<typeof TimesheetSelectAllPayloadSchema>;

export const TimesheetSiderDidNotWorkEventName = "timesheet - sider did not work";
export const TimesheetSiderDidNotWorkPayloadSchema = z.object({
    organisationId: z.string(),
    organisationName: z.string(),
    multiple: z.boolean(),
    source: z.string(),
});
export type TimesheetSiderDidNotWorkPayload = z.infer<typeof TimesheetSiderDidNotWorkPayloadSchema>;

export const TimesheetUserImportAttendancesEventName = "timesheet - user import attendances";
export const TimesheetUserImportAttendancesPayloadSchema = z.object({
    organisationId: z.string(),
    companyName: z.string(),
    success: z.boolean(),
    dbAttDuplicateErrorCount: z.number().optional(),
    fileAttDuplicateErrorCount: z.number().optional(),
    shiftsNotFoundErrorCount: z.number().optional(),
    emptyErrorCount: z.number().optional(),
    formatErrorCount: z.number().optional(),
    missingColumnErrorCount: z.number().optional(),
    uniqueSiderCount: z.number().optional(),
    failedLineCount: z.number().optional(),
    industry: z.string().optional(),
    siderIdError: z.number().optional(),
});
export type TimesheetUserImportAttendancesPayload = z.infer<
    typeof TimesheetUserImportAttendancesPayloadSchema
>;

export const TimesheetValidatesAttendanceEventName = "timesheet - validates attendance";
export const TimesheetValidatesAttendancePayloadSchema = z.object({
    organisationId: z.string(),
    organisationName: z.string(),
    multiple: z.boolean(),
    allSelected: z.boolean(),
    role: z.string(),
});
export type TimesheetValidatesAttendancePayload = z.infer<
    typeof TimesheetValidatesAttendancePayloadSchema
>;

export const TimesheetViewPageEventName = "timesheet - view page";
export const TimesheetViewPagePayloadSchema = z.object({
    logas: z.any(),
    organizationId: z.any(),
    deviceType: z.any(),
});
export type TimesheetViewPagePayload = z.infer<typeof TimesheetViewPagePayloadSchema>;

export const TimesheetsRowsDeletedEventName = "timesheets - rows deleted";
export const TimesheetsRowsDeletedPayloadSchema = z.object({
    organisationId: z.string(),
    selection: z.string(),
    count: z.number(),
    action: z.string(),
});
export type TimesheetsRowsDeletedPayload = z.infer<typeof TimesheetsRowsDeletedPayloadSchema>;

export const TimesheetsRowsValidatedEventName = "timesheets - rows validated";
export const TimesheetsRowsValidatedPayloadSchema = z.object({
    organisationId: z.string(),
    attendanceConfigType: z.any(),
    selection: z.string(),
    count: z.number(),
});
export type TimesheetsRowsValidatedPayload = z.infer<typeof TimesheetsRowsValidatedPayloadSchema>;

export type AnalyticsEventMap = {
    [BbhorizonUserClicksTabbuttonEventName]: BbhorizonUserClicksTabbuttonPayload;
    [BbhorizonUserClicksToDisplayFormEventName]: BbhorizonUserClicksToDisplayFormPayload;
    [BbhorizonUserSendsCdiRequestEventName]: BbhorizonUserSendsCdiRequestPayload;
    [BbhorizonUserWebNotificationEventName]: BbhorizonUserWebNotificationPayload;
    [BulkshiftCreatedShiftEventName]: BulkshiftCreatedShiftPayload;
    [BulkshiftDeletedShiftEventName]: BulkshiftDeletedShiftPayload;
    [BulkshiftDeletedShiftsEventName]: BulkshiftDeletedShiftsPayload;
    [BulkshiftEditedShiftEventName]: BulkshiftEditedShiftPayload;
    [CompanyfeedbackSaveEventName]: CompanyfeedbackSavePayload;
    [CompanymotivesCreatedJustificationEventName]: CompanymotivesCreatedJustificationPayload;
    [CompanymotivesDeletedJustificationEventName]: CompanymotivesDeletedJustificationPayload;
    [ContactsidersEventName]: ContactsidersPayload;
    [CreatedaccountEventName]: CreatedaccountPayload;
    [CreatedprofileEventName]: CreatedprofilePayload;
    [DashboardOpenedTabEventName]: DashboardOpenedTabPayload;
    [FeatureusedEventName]: FeatureusedPayload;
    [FeedbackCompletedRatingEventName]: FeedbackCompletedRatingPayload;
    [FeedbackStoppedRatingEventName]: FeedbackStoppedRatingPayload;
    [GetidentificationdataEventName]: GetidentificationdataPayload;
    [GuestfeedbackFeedbackSentEventName]: GuestfeedbackFeedbackSentPayload;
    [GuestfeedbackOpenEventName]: GuestfeedbackOpenPayload;
    [InvitedteammemberEventName]: InvitedteammemberPayload;
    [InvoicesBulkDownloadEventName]: InvoicesBulkDownloadPayload;
    [InvoicesSingleInvoiceDownloadEventName]: InvoicesSingleInvoiceDownloadPayload;
    [IsnewaccountEventName]: IsnewaccountPayload;
    [JobDescriptionsCreateJobDescriptionEventName]: JobDescriptionsCreateJobDescriptionPayload;
    [JobDescriptionsUseJobDescriptionEventName]: JobDescriptionsUseJobDescriptionPayload;
    [JobpostingAddExternalWorkAgainEventName]: JobpostingAddExternalWorkAgainPayload;
    [JobpostingAddedCustomNameEventName]: JobpostingAddedCustomNamePayload;
    [JobpostingEstimationClickedEventName]: JobpostingEstimationClickedPayload;
    [JobpostingFlexiblePlanningPostedEventName]: JobpostingFlexiblePlanningPostedPayload;
    [JobpostingPlanningTypeSelectedEventName]: JobpostingPlanningTypeSelectedPayload;
    [JobpostingStartedPostingTaskEventName]: JobpostingStartedPostingTaskPayload;
    [JobpostingTaskPostedEventName]: JobpostingTaskPostedPayload;
    [JobpostingUserClickedPreselectVivierEventName]: JobpostingUserClickedPreselectVivierPayload;
    [JobpostingUserSelectSidersEventName]: JobpostingUserSelectSidersPayload;
    [JobpostingVmsDraftModificationEventName]: JobpostingVmsDraftModificationPayload;
    [MissionCancellationEventName]: MissionCancellationPayload;
    [NetworktasksLoadViewEventName]: NetworktasksLoadViewPayload;
    [OrgaUserCompletedSignupFormEventName]: OrgaUserCompletedSignupFormPayload;
    [PaidstudentEventName]: PaidstudentPayload;
    [PlanningEditionDraftEventName]: PlanningEditionDraftPayload;
    [PlanningEditionSavedEventName]: PlanningEditionSavedPayload;
    [PlanningUserDownloadsPlanningEventName]: PlanningUserDownloadsPlanningPayload;
    [PostingUserExpandPricingEventName]: PostingUserExpandPricingPayload;
    [PostingUserSwitchedTaskTypeEventName]: PostingUserSwitchedTaskTypePayload;
    [ProfileteamClosedSiderProfileDetailsEventName]: ProfileteamClosedSiderProfileDetailsPayload;
    [ProfileteamOpenedConversationsEventName]: ProfileteamOpenedConversationsPayload;
    [ProfileteamOpenedEducationSectionEventName]: ProfileteamOpenedEducationSectionPayload;
    [ProfileteamOpenedPastExperiencesSectionEventName]: ProfileteamOpenedPastExperiencesSectionPayload;
    [ProfileteamOpenedSideMissionsSectionEventName]: ProfileteamOpenedSideMissionsSectionPayload;
    [ProfileteamOpenedSiderProfileDetailsEventName]: ProfileteamOpenedSiderProfileDetailsPayload;
    [ReplacementToggleReplacementEventName]: ReplacementToggleReplacementPayload;
    [SelectedjobtypeEventName]: SelectedjobtypePayload;
    [ServicesServiceCreatedEventName]: ServicesServiceCreatedPayload;
    [SiderProfilePhoneNumberActionEventName]: SiderProfilePhoneNumberActionPayload;
    [SignedinEventName]: SignedinPayload;
    [StartedjobcreationEventName]: StartedjobcreationPayload;
    [StartednewjobpostingEventName]: StartednewjobpostingPayload;
    [TaskUserDisplaysEstimationEventName]: TaskUserDisplaysEstimationPayload;
    [TasksChangeManagerOfTheTaskEventName]: TasksChangeManagerOfTheTaskPayload;
    [TaskslistRenamedTaskEventName]: TaskslistRenamedTaskPayload;
    [TeamGetViewportResolutionEventName]: TeamGetViewportResolutionPayload;
    [TeamIbanUpdatedEventName]: TeamIbanUpdatedPayload;
    [TeamRecapPageSeenEventName]: TeamRecapPageSeenPayload;
    [TeamUpdateTaskFromTaskSummaryEventName]: TeamUpdateTaskFromTaskSummaryPayload;
    [TeamcontractCompanyConfirmedContestationEventName]: TeamcontractCompanyConfirmedContestationPayload;
    [TeamcontractCompanyContestedContractsEventName]: TeamcontractCompanyContestedContractsPayload;
    [TeamcontractCompanyDownloadedContractEventName]: TeamcontractCompanyDownloadedContractPayload;
    [TeamcontractCompanyOpenedMainViewEventName]: TeamcontractCompanyOpenedMainViewPayload;
    [TeamcontractCompanySawContractsEventName]: TeamcontractCompanySawContractsPayload;
    [TeamcontractCompanySignedContractsEventName]: TeamcontractCompanySignedContractsPayload;
    [TeamcontractInsiderRegeneratedContractEventName]: TeamcontractInsiderRegeneratedContractPayload;
    [TimesheetConfirmsAttendanceEditEventName]: TimesheetConfirmsAttendanceEditPayload;
    [TimesheetDisputeAttendanceEventName]: TimesheetDisputeAttendancePayload;
    [TimesheetDownloadCsvExtractEventName]: TimesheetDownloadCsvExtractPayload;
    [TimesheetEditsAttendanceEventName]: TimesheetEditsAttendancePayload;
    [TimesheetFiltersEventName]: TimesheetFiltersPayload;
    [TimesheetSelectAllEventName]: TimesheetSelectAllPayload;
    [TimesheetSiderDidNotWorkEventName]: TimesheetSiderDidNotWorkPayload;
    [TimesheetUserImportAttendancesEventName]: TimesheetUserImportAttendancesPayload;
    [TimesheetValidatesAttendanceEventName]: TimesheetValidatesAttendancePayload;
    [TimesheetViewPageEventName]: TimesheetViewPagePayload;
    [TimesheetsRowsDeletedEventName]: TimesheetsRowsDeletedPayload;
    [TimesheetsRowsValidatedEventName]: TimesheetsRowsValidatedPayload;
};

export type AnalyticsEventName = keyof AnalyticsEventMap;

const analyticsEventSchemas: { [K in AnalyticsEventName]: z.ZodType<AnalyticsEventMap[K]> } = {
    [BbhorizonUserClicksTabbuttonEventName]: BbhorizonUserClicksTabbuttonPayloadSchema,
    [BbhorizonUserClicksToDisplayFormEventName]: BbhorizonUserClicksToDisplayFormPayloadSchema,
    [BbhorizonUserSendsCdiRequestEventName]: BbhorizonUserSendsCdiRequestPayloadSchema,
    [BbhorizonUserWebNotificationEventName]: BbhorizonUserWebNotificationPayloadSchema,
    [BulkshiftCreatedShiftEventName]: BulkshiftCreatedShiftPayloadSchema,
    [BulkshiftDeletedShiftEventName]: BulkshiftDeletedShiftPayloadSchema,
    [BulkshiftDeletedShiftsEventName]: BulkshiftDeletedShiftsPayloadSchema,
    [BulkshiftEditedShiftEventName]: BulkshiftEditedShiftPayloadSchema,
    [CompanyfeedbackSaveEventName]: CompanyfeedbackSavePayloadSchema,
    [CompanymotivesCreatedJustificationEventName]: CompanymotivesCreatedJustificationPayloadSchema,
    [CompanymotivesDeletedJustificationEventName]: CompanymotivesDeletedJustificationPayloadSchema,
    [ContactsidersEventName]: ContactsidersPayloadSchema,
    [CreatedaccountEventName]: CreatedaccountPayloadSchema,
    [CreatedprofileEventName]: CreatedprofilePayloadSchema,
    [DashboardOpenedTabEventName]: DashboardOpenedTabPayloadSchema,
    [FeatureusedEventName]: FeatureusedPayloadSchema,
    [FeedbackCompletedRatingEventName]: FeedbackCompletedRatingPayloadSchema,
    [FeedbackStoppedRatingEventName]: FeedbackStoppedRatingPayloadSchema,
    [GetidentificationdataEventName]: GetidentificationdataPayloadSchema,
    [GuestfeedbackFeedbackSentEventName]: GuestfeedbackFeedbackSentPayloadSchema,
    [GuestfeedbackOpenEventName]: GuestfeedbackOpenPayloadSchema,
    [InvitedteammemberEventName]: InvitedteammemberPayloadSchema,
    [InvoicesBulkDownloadEventName]: InvoicesBulkDownloadPayloadSchema,
    [InvoicesSingleInvoiceDownloadEventName]: InvoicesSingleInvoiceDownloadPayloadSchema,
    [IsnewaccountEventName]: IsnewaccountPayloadSchema,
    [JobDescriptionsCreateJobDescriptionEventName]:
        JobDescriptionsCreateJobDescriptionPayloadSchema,
    [JobDescriptionsUseJobDescriptionEventName]: JobDescriptionsUseJobDescriptionPayloadSchema,
    [JobpostingAddExternalWorkAgainEventName]: JobpostingAddExternalWorkAgainPayloadSchema,
    [JobpostingAddedCustomNameEventName]: JobpostingAddedCustomNamePayloadSchema,
    [JobpostingEstimationClickedEventName]: JobpostingEstimationClickedPayloadSchema,
    [JobpostingFlexiblePlanningPostedEventName]: JobpostingFlexiblePlanningPostedPayloadSchema,
    [JobpostingPlanningTypeSelectedEventName]: JobpostingPlanningTypeSelectedPayloadSchema,
    [JobpostingStartedPostingTaskEventName]: JobpostingStartedPostingTaskPayloadSchema,
    [JobpostingTaskPostedEventName]: JobpostingTaskPostedPayloadSchema,
    [JobpostingUserClickedPreselectVivierEventName]:
        JobpostingUserClickedPreselectVivierPayloadSchema,
    [JobpostingUserSelectSidersEventName]: JobpostingUserSelectSidersPayloadSchema,
    [JobpostingVmsDraftModificationEventName]: JobpostingVmsDraftModificationPayloadSchema,
    [MissionCancellationEventName]: MissionCancellationPayloadSchema,
    [NetworktasksLoadViewEventName]: NetworktasksLoadViewPayloadSchema,
    [OrgaUserCompletedSignupFormEventName]: OrgaUserCompletedSignupFormPayloadSchema,
    [PaidstudentEventName]: PaidstudentPayloadSchema,
    [PlanningEditionDraftEventName]: PlanningEditionDraftPayloadSchema,
    [PlanningEditionSavedEventName]: PlanningEditionSavedPayloadSchema,
    [PlanningUserDownloadsPlanningEventName]: PlanningUserDownloadsPlanningPayloadSchema,
    [PostingUserExpandPricingEventName]: PostingUserExpandPricingPayloadSchema,
    [PostingUserSwitchedTaskTypeEventName]: PostingUserSwitchedTaskTypePayloadSchema,
    [ProfileteamClosedSiderProfileDetailsEventName]:
        ProfileteamClosedSiderProfileDetailsPayloadSchema,
    [ProfileteamOpenedConversationsEventName]: ProfileteamOpenedConversationsPayloadSchema,
    [ProfileteamOpenedEducationSectionEventName]: ProfileteamOpenedEducationSectionPayloadSchema,
    [ProfileteamOpenedPastExperiencesSectionEventName]:
        ProfileteamOpenedPastExperiencesSectionPayloadSchema,
    [ProfileteamOpenedSideMissionsSectionEventName]:
        ProfileteamOpenedSideMissionsSectionPayloadSchema,
    [ProfileteamOpenedSiderProfileDetailsEventName]:
        ProfileteamOpenedSiderProfileDetailsPayloadSchema,
    [ReplacementToggleReplacementEventName]: ReplacementToggleReplacementPayloadSchema,
    [SelectedjobtypeEventName]: SelectedjobtypePayloadSchema,
    [ServicesServiceCreatedEventName]: ServicesServiceCreatedPayloadSchema,
    [SiderProfilePhoneNumberActionEventName]: SiderProfilePhoneNumberActionPayloadSchema,
    [SignedinEventName]: SignedinPayloadSchema,
    [StartedjobcreationEventName]: StartedjobcreationPayloadSchema,
    [StartednewjobpostingEventName]: StartednewjobpostingPayloadSchema,
    [TaskUserDisplaysEstimationEventName]: TaskUserDisplaysEstimationPayloadSchema,
    [TasksChangeManagerOfTheTaskEventName]: TasksChangeManagerOfTheTaskPayloadSchema,
    [TaskslistRenamedTaskEventName]: TaskslistRenamedTaskPayloadSchema,
    [TeamGetViewportResolutionEventName]: TeamGetViewportResolutionPayloadSchema,
    [TeamIbanUpdatedEventName]: TeamIbanUpdatedPayloadSchema,
    [TeamRecapPageSeenEventName]: TeamRecapPageSeenPayloadSchema,
    [TeamUpdateTaskFromTaskSummaryEventName]: TeamUpdateTaskFromTaskSummaryPayloadSchema,
    [TeamcontractCompanyConfirmedContestationEventName]:
        TeamcontractCompanyConfirmedContestationPayloadSchema,
    [TeamcontractCompanyContestedContractsEventName]:
        TeamcontractCompanyContestedContractsPayloadSchema,
    [TeamcontractCompanyDownloadedContractEventName]:
        TeamcontractCompanyDownloadedContractPayloadSchema,
    [TeamcontractCompanyOpenedMainViewEventName]: TeamcontractCompanyOpenedMainViewPayloadSchema,
    [TeamcontractCompanySawContractsEventName]: TeamcontractCompanySawContractsPayloadSchema,
    [TeamcontractCompanySignedContractsEventName]: TeamcontractCompanySignedContractsPayloadSchema,
    [TeamcontractInsiderRegeneratedContractEventName]:
        TeamcontractInsiderRegeneratedContractPayloadSchema,
    [TimesheetConfirmsAttendanceEditEventName]: TimesheetConfirmsAttendanceEditPayloadSchema,
    [TimesheetDisputeAttendanceEventName]: TimesheetDisputeAttendancePayloadSchema,
    [TimesheetDownloadCsvExtractEventName]: TimesheetDownloadCsvExtractPayloadSchema,
    [TimesheetEditsAttendanceEventName]: TimesheetEditsAttendancePayloadSchema,
    [TimesheetFiltersEventName]: TimesheetFiltersPayloadSchema,
    [TimesheetSelectAllEventName]: TimesheetSelectAllPayloadSchema,
    [TimesheetSiderDidNotWorkEventName]: TimesheetSiderDidNotWorkPayloadSchema,
    [TimesheetUserImportAttendancesEventName]: TimesheetUserImportAttendancesPayloadSchema,
    [TimesheetValidatesAttendanceEventName]: TimesheetValidatesAttendancePayloadSchema,
    [TimesheetViewPageEventName]: TimesheetViewPagePayloadSchema,
    [TimesheetsRowsDeletedEventName]: TimesheetsRowsDeletedPayloadSchema,
    [TimesheetsRowsValidatedEventName]: TimesheetsRowsValidatedPayloadSchema,
};

export function createAnalyticsTracker(transport: AnalyticsTransport) {
    return {
        event<TName extends AnalyticsEventName>(eventName: TName) {
            return {
                async track(params: AnalyticsEventMap[TName]): Promise<void> {
                    analyticsEventSchemas[eventName].parse(params);
                    await transport(eventName, params as Record<string, unknown>);
                },
            };
        },
    };
}
